import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SmsReceiptComponent } from './components/sms-receipt/sms-receipt.component';

const routes: Routes = [
  { path: 'receipt/:receiptno', component: SmsReceiptComponent },
  { path: 'merchant-receipt/:receiptno', component: SmsReceiptComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
